import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = ({ children, showFillIn = true }) => {
  return (
    <div className="flex flex-col h-screen">
      {/* Fixed Header */}
      <Header showFillIn={showFillIn} />
      
      <main className="flex-grow overflow-y-auto bg-gray-50">
        <div className="max-w-screen-xl mx-auto">{children}</div>
      </main>
      
      {/* Fixed Footer */}
      <Footer />
    </div>
  );
};

export default Layout;
